import React, {Component} from "react";
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";
import {required, urls} from "./Validation";
import TextareaField from "../TextareaField";
import {fileFormClear, fileFormSetUrls} from "../../../actions/FileFormActions";
import {Trans} from "react-i18next";

class ModalUrlForm extends Component {

    handleSubmit = (value) => {
        const {fileFormSetUrls, closeModal, finishCallback} = this.props;
        const urls = value.split(/\r?\n/);

        fileFormSetUrls(urls);
        closeModal();
        finishCallback();
    };

    componentWillUnmount() {
        this.props.fileFormClear();
    }

    render() {
        const {handleSubmit} = this.props;

        return <form onSubmit={handleSubmit(value => this.handleSubmit(value.url))} className="url-area">
            <span className="label"><Trans>Paste URL here</Trans></span>
            <div className="row">
                <Field
                    name="url"
                    component={TextareaField}
                    validate={[required, urls]}
                    autoFocus
                />
            </div>
            <button className="btn pink"><Trans>ADD URL</Trans></button>
        </form>
    }
}

ModalUrlForm = reduxForm({
    form: 'UrlForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(ModalUrlForm);

export default connect(
    state => ({}),
    dispatch => ({
        fileFormSetUrls: urls => dispatch(fileFormSetUrls(urls)),
        fileFormClear: () => dispatch(fileFormClear()),
    })
)(ModalUrlForm);